import { connect } from 'react-redux';
import AssistantsList from "./AssistantsList";
import {getTranslation} from "../../../reducers/common/localization";
import {MODAL_EDIT_ASSISTANT, MODAL_REMOVE_ASSISTANT, showModal} from "../../../reducers/common/activeModal";
import {
    fetchGetAssistants,
    geAssistantsFormattedData,
    loadingAssistants
} from "../../../reducers/assistant/assistants";
import {resetSubmitFormData} from "../../../reducers/common/submitForm";

const mapStateToProps = state => {
    return {
        loading: loadingAssistants(state),
        data: geAssistantsFormattedData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => dispatch(fetchGetAssistants()),
        onRemoveButtonClick: () => dispatch(showModal({modalKey: MODAL_REMOVE_ASSISTANT})),
        onEditButtonClick: () => dispatch(showModal({modalKey: MODAL_EDIT_ASSISTANT})),
        onResetSubmitFormData: () => dispatch(resetSubmitFormData())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AssistantsList);


// WEBPACK FOOTER //
// ./src/components/assistantsManagement/assistantsList/AssistantsList.container.js